import { AdminConceptFormulaLoading } from '@/views/admin-concept-formula/admin-concept-formula.loading';

export default AdminConceptFormulaLoading;
